import ChangePasswordForm from "./ChangePassword";
import ImportExportProgressForm from "./ImportExportProgress";

const formComponents = {
  ChangePasswordForm,
  ImportExportProgressForm
}

export default formComponents